import { Typography as MuiTypography, Link as MuiLink } from "@mui/material";
import { Trans } from "react-i18next";
import Export from "app/shared/UI/Export";
import { GET_IMPORTS_URL_BASE } from "app/shared/constants";
import { headerStyles, multiLineCell } from "app/shared/UI/sharedStyles";

export const defaultTableColumnHeaders = (t) => [
  {
    field: "irbNumber",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsCohortHistory.irb" />
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 200,
    renderCell: ({ row }) => (
      <MuiTypography sx={multiLineCell}>
        <MuiLink
          href={`${window.location.origin}/outreach/${row.studyId}/conduct`}
          target="_blank"
          rel="noopener noreferrer"
          replace
        >
          {row.irbNumber}
        </MuiLink>
      </MuiTypography>
    ),
  },
  {
    field: "fileName",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsCohortHistory.fileName" />
      </MuiTypography>
    ),
    renderCell: ({ row }) => (
      <MuiTypography sx={multiLineCell}>
        <Export
          displayName={row.fileName}
          // TODO: use wavename_<filename>
          downloadName={row.fileName}
          exportURL={`${GET_IMPORTS_URL_BASE}/${row.importId}/uploaded-file`}
        />
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 400,
  },
  {
    field: "sourceType",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsCohortHistory.cohortSourceType" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>{value}</MuiTypography>
    ),
    flex: 1,
    minWidth: 300,
    sortable: false,
  },
  {
    field: "importedDate",
    renderHeader: () => (
      <MuiTypography style={headerStyles}>
        <Trans i18nKey="ProspectDetailsCohortHistory.cohortImportedDate" />
      </MuiTypography>
    ),
    renderCell: ({ value }) => (
      <MuiTypography sx={multiLineCell}>
        {new Date(value).toLocaleString()}
      </MuiTypography>
    ),
    flex: 1,
    minWidth: 400,
  },
];
